module.exports = __webpack_public_path__ + "static/media/icon_bottle.8337a917.svg";